import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-confirm-check',
  templateUrl: './icon-confirm-check.component.html',
  styles: []
})
export class IconConfirmCheckComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
